import styled from 'styled-components';

export const StyledGuardianModalContent = styled.div`
   display: flex;
   flex-direction: column;
   gap: 18px;
`;
StyledGuardianModalContent.displayName = 'StyledGuardianModalContent';
